import React from 'react';
import { Link } from 'react-router-dom';
import './TabItem.scss';

interface TabItemProps {
  title: string;
  isActive: boolean;
  icon?: React.ReactNode;
  to: string;
}

const TabItem: React.FC<TabItemProps> = ({ title, isActive, icon, to }) => {
  return (
    <Link to={to} className={`tab-item ${isActive ? 'active' : ''}`}>
      {icon && <span className="tab-icon">{icon}</span>}
      <span className="tab-title">{title}</span>
    </Link>
  );
};

export default TabItem;
